module.exports = __webpack_public_path__ + "img/out-step2-en.34205fc1.png";